tetloose.touchDevices = function() {
    var deviceAgent = navigator.userAgent.toLowerCase();

    var isTouchDevice = Modernizr.touch ||
    (deviceAgent.match(/(iphone|ipod|ipad)/) ||
    deviceAgent.match(/(android)/)  ||
    deviceAgent.match(/(iemobile)/) ||
    deviceAgent.match(/iphone/i) ||
    deviceAgent.match(/ipad/i) ||
    deviceAgent.match(/ipod/i) ||
    deviceAgent.match(/blackberry/i) ||
    deviceAgent.match(/bada/i));

    if (isTouchDevice) {
        $html.removeClass('no-touchevents');
        $html.addClass('touchevents mobile');
    } else {
        $html.removeClass('touchevents');
        $html.addClass('no-touchevents');
    }
};
